// AppraisalArticle.tsx
import { Col, Row } from "react-bootstrap";
import MaterialIcon from "../../material-icon";
import { colorPalette } from "../../../utils/theme";
import useIsMobile from "../../../hooks/useIsMobile";
import { ArticleImage, ArticleTitle, ArticleSubtitle, SharingContainer, ArticleDescription, Headline, ThreeDots, BulletPointList, BulletPointItem, ArticleText, FilterContainer, StyledLink, AuthorRole, AuthorAvatar, AuthorName, SubHeadline, Divider, ArticleImageContainer, PlayButton, YouTubeFrame, VideoLoadingContainer, NumberedItem, NumberedList } from "../article.styles";
import AppraisalImage from "../../../assets/images/articles/appraisal-large.webp";
import AppraisalMobileImage from "../../../assets/images/articles/appraisal.webp";
import CTAButton from "../../cta-button/cta-button";
import { useCallback } from "react";
import { useTranslation } from 'react-i18next';
import useCustomNavigate from "../../../hooks/useCustomNavigate";
interface AppraisalArticleProps {
    onClickShare: () => void;
}

const AppraisalArticle: React.FC<AppraisalArticleProps> = ({ onClickShare }) => {
    const isMobile = useIsMobile();
    const { t } = useTranslation();
    const navigate = useCustomNavigate();

    const renderHeaderContent = useCallback(() => {
        return (
            <ArticleImageContainer>
                <ArticleImage
                    src={isMobile ? AppraisalMobileImage : AppraisalImage}
                    alt="Article Thumbnail"
                    showBorderRadius={!isMobile}
                />
            </ArticleImageContainer>
        );
    }, []);

    return (
        <>
            {isMobile && (
                renderHeaderContent()
            )}

            <Row className="justify-content-center flex-grow-1" style={{ paddingLeft: 16, paddingRight: 16 }}>
                <Col xs={12} lg={8} xl={6}>
                    <ArticleTitle>{t("articles.appraisal.title")}</ArticleTitle>
                    <ArticleSubtitle>{t("articles.appraisal.subtitle")}</ArticleSubtitle>

                    <SharingContainer>
                        <AuthorName>Managd Knowledge Hub</AuthorName>
                        <MaterialIcon icon="share" size={24} color={colorPalette.textDark} onClick={onClickShare} />
                    </SharingContainer>

                    {!isMobile && (
                        renderHeaderContent()
                    )}

                    <ArticleDescription>{t("articles.appraisal.intro")}</ArticleDescription>

                    <ThreeDots />

                    <Headline>{t("articles.appraisal.section1_title")}</Headline>
                    <ArticleText>{t("articles.appraisal.section1_text")}</ArticleText>
                    <BulletPointList>
                        <BulletPointItem>{t("articles.appraisal.section1_bullet1")}</BulletPointItem>
                        <BulletPointItem>{t("articles.appraisal.section1_bullet2")}</BulletPointItem>
                        <BulletPointItem>{t("articles.appraisal.section1_bullet3")}</BulletPointItem>
                    </BulletPointList>

                    <ArticleText>{t("articles.appraisal.section1_outro")}</ArticleText>

                    <ThreeDots />

                    <Headline>{t("articles.appraisal.section2_title")}</Headline>
                    <ArticleText>{t("articles.appraisal.section2_text")}</ArticleText>
                    <BulletPointList>
                        <BulletPointItem>{t("articles.appraisal.section2_bullet1")}</BulletPointItem>
                        <BulletPointItem>{t("articles.appraisal.section2_bullet2")}</BulletPointItem>
                        <BulletPointItem>{t("articles.appraisal.section2_bullet3")}</BulletPointItem>
                        <BulletPointItem>{t("articles.appraisal.section2_bullet4")}</BulletPointItem>
                    </BulletPointList>

                    <ArticleText>{t("articles.appraisal.section2_outro")}</ArticleText>

                    <ThreeDots />

                    <Headline>{t("articles.appraisal.section3_title")}</Headline>
                    <ArticleText>{t("articles.appraisal.section3_text")}</ArticleText>
                    <BulletPointList>
                        <BulletPointItem>{t("articles.appraisal.section3_bullet1")}</BulletPointItem>
                        <BulletPointItem>{t("articles.appraisal.section3_bullet2")}</BulletPointItem>
                        <BulletPointItem>{t("articles.appraisal.section3_bullet3")}</BulletPointItem>
                    </BulletPointList>

                    <ArticleText>{t("articles.appraisal.section3_outro")}</ArticleText>

                    <ThreeDots />

                    <Headline>{t("articles.appraisal.section4_title")}</Headline>
                    <BulletPointList>
                        <BulletPointItem>{t("articles.appraisal.section4_bullet1")}</BulletPointItem>
                        <BulletPointItem>{t("articles.appraisal.section4_bullet2")}</BulletPointItem>
                        <BulletPointItem>{t("articles.appraisal.section4_bullet3")}</BulletPointItem>
                    </BulletPointList>

                    <ThreeDots />

                    <CTAButton
                        className="mb-4"
                        variant="primary"
                        size="M"
                        label={t("pages.knowledge_hub.articles.appraisal.order_appraisal")}
                        icon="open_in_new"
                        onClick={() => navigate("/book-valuation")}
                        fullWidth={isMobile}
                    />
                </Col>
            </Row>
        </>
    );
};

export default AppraisalArticle;
